import ErrorMessage from 'components/ErrorMessage'
import React from 'react'

const OFileInput = (props) => {
	const { wrapperClassName, name, inputLabel, register, errors, ...rest } = props

	return (
		<div className={wrapperClassName ?? 'relative z-0 mb-6 w-full group'}>
			{/* <label for={name} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{inputLabel}</label> */}

			<label className='block mb-2 text-sm font-medium text-gray-900 dark:text-white' for='file_input'>
				{inputLabel || 'Upload file'}
			</label>
			<input
				className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
				id='file_input'
				type='file'
				name={name}
				{...register}
				{...rest}
			/>

			<ErrorMessage message={errors?.[name]?.message} />
		</div>
	)
}

export default OFileInput
